<template>
  <span class="visit" title="nombre de visite">{{ visit }}</span>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'Visit',
  props: ['visit'],
  components: {}
})
class Visit extends Vue {
  @Prop visit
}

export default Visit
</script>

<style scoped lang="less">
  .visit {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    width: 26px;

    color: white;
    text-align: center;

    border-radius: 50%;
    background-color: #b715401a;
    color: #b71540;
    font-weight: bold;
  }
</style>
